import { render, staticRenderFns } from "./DlvL_Search.vue?vue&type=template&id=5202fc0a"
import script from "./DlvL_Search.vue?vue&type=script&lang=js"
export * from "./DlvL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports